export default "__VITE_ASSET__BKCJeIVP__"